export const FLAG_ID = 'bulk-operations-core.edit-form.edit-form-status-flags.partial-error-flag';
export const TEST_ID =
	'bulk-operations-core.ui.edit-form.edit-form-status-flags.partial-error-flag';
export const BULK_EDIT_ERROR_LEARN_MODE_ARTICLE_ID = '62h4g5fA9BUhungZSSNyEl';
